var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"adminButton",class:{
    'adminButton--link':
      _vm.arrow || _vm.layout === 'link' || _vm.layout === 'link-arrow',
    'adminButton--linkArrow': _vm.arrow && typeof _vm.arrow === 'string',
    'adminButton--linkArrowBefore': _vm.arrow && _vm.arrow === 'before',
    'adminButton--linkArrowAfter': _vm.arrow && _vm.arrow === 'after'
  },attrs:{"type":_vm.type,"disabled":_vm.disabled}},[(_vm.arrow === 'before')?_c('arrow'):_vm._e(),_vm._t("default"),(_vm.arrow === 'after')?_c('arrow'):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }